import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { ShipmentChargesFormField } from './ShipmentChargesFormField'

export const ShipmentChargesNature = ({ dataState, setDataState, disabled }) => {
    const { t } = useTranslation()

    const natureOptions = [
        { label: 'Debit', value: 'D' },
        { label: 'Credit', value: 'C' },
    ]

    const field = {
        display: t('Nature'),
        required: true,
        code: 'Nature',
        type: 'select',
        options: natureOptions,
        grow: true,
    }

    return (
        <M_Fieldset
            labelInside
            style={{ height: '100%', width: '100%', boxSizing: 'border-box', flex: 1 }}
            label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                    {t('Nature')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '10px', height: '100%' }}>
                    <ShipmentChargesFormField
                        fields={field}
                        index={0}
                        data={dataState}
                        setData={setDataState}
                        options={natureOptions}
                        disabled={disabled}
                    />
                </div>
            }
        />
    )
}
